/**
 * Channels API Client
 *
 * Loads workspace channels with integration info.
 */

import apiClient from '../api-client'

export interface Channel {
  id: string
  channel_name: string
  channel_type: number
  is_active: boolean
  workspace_integration_id: string
  integration_name: string
  integration_type: string
}

export interface ChannelRequirement {
  id: string
  channel_id: string
  min_width: number | null
  min_height: number | null
  max_width: number | null
  max_height: number | null
  allowed_formats: string[] | null
}

export async function getChannels(includeInactive = false): Promise<{
  success: boolean
  channels: Channel[]
}> {
  const params = includeInactive ? { include_inactive: 'true' } : {}
  const response = await apiClient.get('/api/v1/channels', { params })
  return response.data
}

export async function getAllChannelRequirements(): Promise<{
  success: boolean
  requirements: ChannelRequirement[]
}> {
  const response = await apiClient.get('/api/v1/channels/requirements')
  return response.data
}
